import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { FormControl, FormControlLabel, Radio, RadioGroup } from '../atom'

interface IList {
  label: string
}

interface Props {
  list?: IList[]
  onChange?: (value: string) => void
  value?: string
  row?: boolean
}

const Wrapper = styled.div`
  display: flex;
  padding: 12px;
  border-radius: 4px;
  gap: 8px;
  border: 1px solid #e6e6e6;

  .MuiFormControlLabel-label {
    word-break: keep-all;
    overflow-wrap: normal;
  }
`

const ColumnRadioButton = (props: Props) => {
  const { list, onChange, value, row } = props
  const [selectedValue, setSelectedValue] = useState('0')

  useEffect(() => {
    if (value) setSelectedValue(value)
  }, [value])

  const handleRadioButton = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value
    setSelectedValue(newValue)
    if (onChange) {
      onChange(newValue)
    }
  }

  const controlProps = (item: string) => ({
    checked: selectedValue === item,
    onChange: handleRadioButton,
    value: item,
    name: 'color-radio-button',
    inputProps: { 'aria-label': item },
  })

  return (
    <Wrapper>
      <FormControl>
        <RadioGroup row={row} value={selectedValue} onChange={handleRadioButton}>
          {list?.map((item, index) => (
            <FormControlLabel
              control={
                <Radio
                  {...controlProps(`${index}`)}
                  sx={{
                    '&.Mui-checked': {
                      color: '#57C9A7',
                    },
                  }}
                  size="small"
                />
              }
              label={item.label}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Wrapper>
  )
}

export default ColumnRadioButton
